import { combineReducers, configureStore } from "@reduxjs/toolkit"

import customAlertSlice from "./reducers/app/CustomAlertSlice"
import responseInfoSlices from "./reducers/app/ResponseInfoSlices"

import themeSlice from "./reducers/app/ThemeSlice"
import languageSlice from "./reducers/app/LanguageSlice"

import profileRemoveDataSlice from "./reducers/ProfileRemoveDataSlice"
import profileTrashDataSlice from "./reducers/ProfileTrashDataSlice"

const rootReducer = combineReducers({

    customAlert: customAlertSlice,
    responseInfo: responseInfoSlices,

    theme: themeSlice,
    language: languageSlice,

    profileRemoveData: profileRemoveDataSlice,
    profileTrashData: profileTrashDataSlice,
})

export const setupStore = () => {
    return configureStore({
        reducer: rootReducer
    })
}

export type RootState = ReturnType<typeof rootReducer>
export type AppStore = ReturnType<typeof setupStore>
export type AppDispatch = AppStore['dispatch']